/**
 * Central GSAP setup for the whole app.
 *
 * Plugins are registered exactly ONCE here (ES modules are singletons), and every
 * other file imports `gsap` / `ScrollTrigger` FROM this module — so there is never
 * a duplicate registration and all animation stays funnelled through one place
 * (per the redesign brief's GSAP-architecture rules).
 *
 * IMPORTANT — reduced motion: GSAP drives animation from JavaScript (requestAnimationFrame
 * writing inline transforms), which the CSS `@media (prefers-reduced-motion: reduce)`
 * guard in theme.css CANNOT stop. So every motion hook in `ui/motion` checks
 * `prefersReducedMotion()` and jumps straight to the final state instead of animating.
 */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * True when the user (or OS) requests reduced motion. SSR-safe (Vite SPA, but
 * guarded anyway). Read at animation-setup time so it reflects the current setting.
 */
export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export { gsap, ScrollTrigger };
